import FormSubmitErrorMessage from './form-submit-error-message';
import './form-submit-error-message.scss';

export default FormSubmitErrorMessage;
